import React from 'react';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage: React.FC = () => {
  const companyName = "VKS TRADERS";
  const lastUpdatedDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="privacy-policy-page-container">
      <div className="privacy-policy-content-card">
        <h1>Privacy Policy</h1>
        <span className="last-updated">Last Updated: {lastUpdatedDate}</span>

        <p>
          Welcome to {companyName}. We are committed to protecting your privacy.
          This Privacy Policy explains how we collect, use, disclose, and
          safeguard your information when you use our platform.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect personal information from you in a variety of ways, including:</p>
        <ul>
          <li>
            <strong>Personal Identification Information:</strong> Name, username,
            email address, mobile number, city, and other contact details you
            provide upon registration.
          </li>
          <li>
            <strong>Financial Information:</strong> Bank account number, IFSC code,
            bank name, and PAN number for the purpose of processing payouts and
            complying with legal requirements.
          </li>
          <li>
            <strong>Transactional Information:</strong> Details about your
            wallet transactions, member registrations, and other activities on
            the platform.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>
          We use the information we collect for various purposes, including to:
        </p>
        <ul>
          <li>Create and manage your account.</li>
          <li>Process transactions and send you related information, including confirmations and invoices.</li>
          <li>Calculate and process your earnings and payouts.</li>
          <li>Communicate with you about your account or our services.</li>
          <li>Comply with legal and regulatory obligations (e.g., tax reporting).</li>
          <li>Monitor and analyze usage and trends to improve your experience.</li>
          <li>Prevent fraudulent activity and enhance the security of our platform.</li>
        </ul>

        <h2>3. Disclosure of Your Information</h2>
        <p>
          We do not sell, trade, or rent your personal identification
          information to others. We may share your information in the following
          situations:
        </p>
        <ul>
          <li>
            <strong>With Your Sponsor:</strong> Your name and username may be
            visible to your direct sponsor and upline members as part of the
            network structure.
          </li>
          <li>
            <strong>For Legal Reasons:</strong> We may disclose your information
            if required to do so by law or in response to valid requests by
            public authorities (e.g., a court or a government agency).
          </li>
        </ul>

        <h2>4. Security of Your Information</h2>
        <p>
          We use administrative, technical, and physical security measures to
          help protect your personal information. While we have taken
          reasonable steps to secure the personal information you provide to us,
          please be aware that despite our efforts, no security measures are
          perfect or impenetrable.
        </p>

        <h2>5. Your Rights</h2>
        <p>
          You have the right to access and update your personal and banking
          information through your "My Profile" page. If you wish to terminate
          your account, please contact our support team.
        </p>

        <h2>6. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify
          you of any changes by posting the new Privacy Policy on this page. You
          are advised to review this Privacy Policy periodically for any
          changes.
        </p>

        <h2>7. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us
          at: +91 861 086 4055
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;